import request from "@/utils/request";

// 首页获取女神专辑图信息, servicePlaces工作地点，Array类型，代表可以多选
export function getGoddess(servicePlaces, pagination) {
  // 全部不需要带employers参数
  if (servicePlaces === "全部") {
    servicePlaces = undefined;
  }
  const page = pagination.page + 1;
  return request({
    url: "/home/goddess/album/list",
    method: "get",
    params: {
      employers: servicePlaces,
      page: page,
      size: 10
    }
  });
}

export function getGoddessFilter({
  maxAge,
  minAge,
  maxHeight,
  minHeight,
  bust,
  selectedNationalities,
  selectedServicePlaces
}) {
  let age;
  let height;
  if (minHeight && maxHeight) {
    height = `${minHeight},${maxHeight}`;
  }
  if (minAge && maxAge) {
    age = `${minAge},${maxAge}`;
  }
  return request({
    url: "/home/goddess/album/list",
    method: "get",
    params: {
      age,
      height,
      bust: bust,
      employers: selectedServicePlaces,
      nationalitys: selectedNationalities
    }
  });
}

export function getPersonalHomeInfo(id) {
  return request({
    url: "/homepage/base/info",
    method: "get",
    params: {
      customerId: id
    }
  });
}

export function getPersonalHomeVideos(id) {
  return request({
    url: "/homepage/short/video",
    method: "get",
    params: {
      customerId: id
    }
  });
}

export function getPersonalHomePhotos(id) {
  return request({
    url: "/homepage/album",
    method: "get",
    params: {
      customerId: id
    }
  });
}

export function searchGoddess(keyword) {
  return request({
    url: "/home/search",
    method: "get",
    params: {
      keyword,
      size: 100
    }
  });
}
export function getGoddessQQ(id) {
  return request({
    url: "/homepage/msg",
    method: "get",
    params: {
      id
    }
  });
}
